// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"build-info-module--wrapper--fK9Aa"};